module.exports = __webpack_public_path__ + "img/3.c300b425.png";